import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionComponent } from './accordion.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
	declarations: [AccordionComponent],
	imports: [ CommonModule, MatExpansionModule, MatIconModule, MatTooltipModule, FormsModule, ReactiveFormsModule ],
	exports: [AccordionComponent]
})
export class AccordionModule {}
